import React, { useState } from "react";
import Modal from "react-modal";

import {
  NavLink,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Faculties from "./Faculties";
import Leaders from "./Leaders";
import Teachers from "./Teachers";
import ChatBot from "./ChatBot";
import LF from "./LandingForm/LF";
import Preview from "./Preview";
import LinkYourAccounts from "./Step4/LinkYourAccounts";
import Occasions from "./Step4/Occasions";
import NewRecognitions from "./Recognition/NewRecognitions";
import NewTestimonials from "./Testimonials/NewTestimonials";
import NewBranding from "./Brochures/NewBranding";
import NewCampusInfo from "./CampusInfo/NewCampusInfo";
import Notifications from "./Step4/Notifications";
import ParentInsights from "./Step5/ParentInsights";
import AIManagmentHub from "./Step6/AIManagmentHub";
import AutoConnectHub from "./Step2/AutoConnectHub";
import { Img } from "./_local/components";
import ContentEngagement from "./Step4/ContentEngagement";
import ProcessComplete from "./ProcessComplete";
import NewAutoFeeHub from "./Step3/AutoFeeHub/NewAutoFeeHub";
import Template from "./Template";
import Stopwatch from "./_local/components/Stopwatch";
import Lottie from "lottie-react";
import RedDotAnimation from "./_local/assets/images/RedDotAnimation.json";
import WhatsApp from "./Whatsapp";
import TemplateMedia from "./TemplateMedia";
import { AppProvider, useGlobalState } from "./_local/state";
import { ModalProvider } from "./_local/components/GlobalModal";

Modal.setAppElement("#root");

const SFRContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { instData } = useGlobalState();
  const [modalState, setModalState] = useState<{
    route: string;
    display: boolean;
  }>({
    route: "",
    display: false,
  });

  const areBIDAndInsIdPresent = () => {
    return instData?.BRANCH_ID && instData?.INSTITUTE_ID;
  };

  const [formKey, setFormKey] = React.useState(Date.now());

  let instituteData = null;
  try {
    instituteData = JSON.parse(sessionStorage?.getItem("_DATA_") || "{}");
  } catch (err) {}

  const YOUR_WEBSITE_FORMS = [
    {
      label: "School Info",
      route: "/old/onboarding/instituteInfo",
      value: sessionStorage.getItem("Institute"),
      id: "Institute",
      required: true,
    },
    {
      label: "Founders/Leader info",
      route: "/old/onboarding/instituteInfo/founders",
      value: sessionStorage.getItem("founders"),
      id: "founders",
      required: true,
    },
    {
      label: "Faculty/Teachers info",
      route: "/old/onboarding/instituteInfo/faculties",
      value: sessionStorage.getItem("faculties"),
      id: "faculties",
      required: true,
    },
    {
      label: "Recognitions",
      route: "/old/onboarding/instituteInfo/recognition",
      value: sessionStorage.getItem("recognitions"),
      id: "recognitions",
    },
    {
      label: "Template",
      route: "/old/onboarding/instituteInfo/template",
      value: sessionStorage.getItem("template"),
      id: "template",
      required: true,
    },
    {
      label: "Media",
      route: "/old/onboarding/instituteInfo/templateMedia",
      value: sessionStorage.getItem("templateMedia"),
      id: "templateMedia",
      required: true,
    },
    // {
    //   label: "Campus Info",
    //   route: "/old/onboarding/instituteInfo/campusinfo",
    //   value: sessionStorage.getItem("campus"),
    //   id: "campus",
    // },
    {
      label: "AI Avatar",
      route: "/old/onboarding/instituteInfo/chatbot",
      value: sessionStorage.getItem("Chatbot"),
      id: "aiAvatar",
      required: true,
    },
    {
      label: "Testimonials",
      route: "/old/onboarding/instituteInfo/testimonials",
      value: sessionStorage.getItem("testimonials"),
      id: "testimonials",
    },
    {
      label: "Branding Materials",
      route: "/old/onboarding/instituteInfo/branding",
      value: sessionStorage.getItem("materials"),
      id: "materials",
    },
  ];

  const SOCIAL_HUB_FORMS = [
    {
      label: "Link your accounts",
      route: "/old/onboarding/socialHubInfo",
      value: sessionStorage.getItem("socialHubInfo"),
    },
    {
      label: "Occasions",
      route: "/old/onboarding/socialHubInfo/occasions",
      value: sessionStorage.getItem("occasions"),
    },
    // { label: "Select notifications", route: "/old/onboarding/socialHubInfo/notification", value: sessionStorage.getItem("notification") },
    {
      label: "Content engagement",
      route: "/old/onboarding/socialHubInfo/content-engagement",
      value: sessionStorage.getItem("countentEngagement"),
    },
  ];

  const AUTO_FEE_HUB__FORMS = [
    {
      label: "Auto Fee Hub",
      route: "/old/onboarding/autoFeeHub",
      value: sessionStorage.getItem("autoFeeHub"),
      id: "autoFeeHub",
    },
  ];

  const AUTO_CONNECT_HUB__FORMS = [
    {
      label: "Auto Connect Hub",
      route: "/old/onboarding/autoConnectHub",
      value: sessionStorage.getItem("autoConnectHub"),
      id: "autoConnectHub",
    },
  ];

  const AI_MANAGMENT_HUB__FORMS = [
    {
      label: "AI Management Hub",
      route: "/old/onboarding/aiManagementHub",
      value: sessionStorage.getItem("aiManagementHub"),
      id: "aiManagementHub",
    },
  ];

  const PARENTAL_INSIGHTS = [
    {
      label: "Parental insights",
      route: "/old/onboarding/parentalInsights",
      value: sessionStorage.getItem("parentalInsights"),
      id: "parentalInsights",
    },
  ];

  const STEPS = [
    {
      label: "Your Website",
      options: YOUR_WEBSITE_FORMS,
      route: "/old/onboarding/instituteInfo",
      id: "instituteInfo",
      status: !!instituteData?.BRANCH_ID,
    },
    {
      label: "Auto Connect Setup",
      options: AUTO_CONNECT_HUB__FORMS,
      route: "/old/onboarding/autoConnectHub",
      id: "autoConnectHub",
      status: "",
    },
    {
      label: "Auto Fee Hub Integration",
      options: AUTO_FEE_HUB__FORMS,
      route: "/old/onboarding/autoFeeHub",
      id: "autoFeeHub",
      status: "",
    },
    {
      label: "Social Hub Integration",
      options: SOCIAL_HUB_FORMS,
      route: "/old/onboarding/socialHubInfo",
      id: "socialHubInfo",
      status: "",
    },
    {
      label: "Parental insights",
      options: PARENTAL_INSIGHTS,
      route: "/old/onboarding/parentalInsights",
      id: "parentalInsights",
      status: "",
    },
    {
      label: "AI Management Hub",
      options: AI_MANAGMENT_HUB__FORMS,
      route: "/old/onboarding/aiManagementHub",
      id: "aiManagementHub",
      status: "",
    },
  ];

  function getStepObject(url) {
    const currentStep = STEPS?.find(
      (step) => url === step?.route || url?.startsWith(`${step?.route}/`)
    );
    return currentStep?.options || ([] as any);
  }

  const renderNavLinkClasses = (route?) => {
    if (location?.pathname === route) {
      return {
        value:
          "text-[2.4vh] inline-block py-2 px-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500",
        clickable: true,
      };
    } else {
      return {
        value:
          "text-[2.4vh] inline-block py-2 px-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300",
        clickable: false,
      };
    }
  };

  const resetFormData = () => {
    sessionStorage.removeItem(
      getStepObject(location?.pathname)?.find(
        (item) => item?.route === location?.pathname
      )?.id
    );
    setFormKey((formKey) => Date.now());
  };

  const handleNavigate = (preview?: boolean, link?: string) => {
    if (preview) {
      // navigate("/old/onboarding/instituteInfo/preview");
      window.location.href = "/old/onboarding/instituteInfo/preview";
    } else if (link) {
      navigate(link);
    } else {
      navigate(
        getStepObject(location?.pathname)?.[
          getStepObject(location?.pathname)?.findIndex(
            (item) => item?.route === location?.pathname
          ) + 1
        ]?.route
      );
    }
  };

  function canNavigate(array, index, checkForTab = false) {
    if (checkForTab) {
      if (index === 0) return true; // If index is 0, return true

      // Get the previous index value from the array
      const previousItem = array?.[index - 1];

      // Check if previousItem exists and has a truthy value
      return previousItem?.value ? true : false;
    } else {
      if (index === 0) return true; // If index is 0, return true

      // Get the previous index value from the array
      const previousItem = array?.[index - 1];

      // Check if previousItem exists and has a truthy value
      return !!previousItem?.status ? true : false;
    }
  }

  const onRequestClose = () => {
    setModalState({ route: "", display: false });
  };

  return (
    <div
      key={formKey}
      className="mx-auto font-manrope text-gray-ob sm:px-4 lg:px-8"
    >
      <nav className="flex w-full justify-between items-center bg-[#F9EBFF] p-1 sm:p-4">
        <div className="flex w-full items-center gap-2 sm:gap-4">
          <NavLink to="/" style={{ width: "3.5vw" }}>
            <Img
              // className="w-[10vw] sm:w-[6vw] lg:w-[3vw] h-[6vh] object-contain"
              className="h-[6vh] w-auto max-w-[120px] object-contain"
              src={"/images/Logo.svg"}
              alt="SooMuch Logo"
              loading={"lazy"}
            />
          </NavLink>
          <p className="font-semibold sm:text-lg md:text-xl text-[2.4vh]">
            Onboarding Setup
          </p>
        </div>
        <div className="flex gap-4 justify-end items-center w-[25%]">
          {!!instData?.BRANCH_ID && <Stopwatch />}
          <button
            onClick={() => window.open("https://soomuch.ai/explore", "_blank")}
            type="button"
            className="flex items-center gap-2 p-2 bg-[white] text-[#EA4040] font-manropeSB w-fit rounded-xl"
          >
            <Lottie animationData={RedDotAnimation} className="w-5" />
            Live Demo
          </button>
        </div>
      </nav>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4 p-2">
        {![
          "/old/onboarding/onboarding-complete",
          "/old/onboarding/onboarding-whatsapp",
        ].includes(location?.pathname) && (
          <div className="col-span-12 sm:hidden md:hidden laptop:block">
            <div className="newStepperWrapperOB">
              {/* {STEPS?.map((item, index) => (
                <NavLink
                  // to={item?.route} key={"alsdkjasbdasdmasd" + index} className={`newStepperItemOB ${location?.pathname?.includes(item?.id) ? "newActiveOB newCompletedOB" : ""}`}
                  to={item?.route}
                  key={"alsdkjasbdasdmasd" + index}
                  className={`newStepperItemOB ${
                    location?.pathname?.includes(item?.id) ? `newActiveOB` : ""
                  } ${!!item?.status && "newCompletedOB"}`}
                  // style={{ pointerEvents: canNavigate(STEPS, index) ? "auto" : "none", color: !canNavigate(STEPS, index) && "gray" }}
                >
                  <div
                    className={`newStepCounterOB ${
                      location?.pathname?.includes(item?.id)
                        ? "newActiveOB"
                        : ""
                    }`}
                  >
                    <div className="newCounterBubble" />
                  </div>
                  <div className="font-semibold text-[2vh] text-center w-[70%]">
                    Step {index + 1}
                  </div>
                  <div className="text-[2vh] text-center w-[70%] mt-1">
                    {item?.label}
                  </div>
                </NavLink>
              ))} */}
              {STEPS?.map((item, index) => (
                <div
                  key={"alsdkjasbdasdmasd" + index}
                  onClick={() => {
                    if (
                      areBIDAndInsIdPresent() ||
                      item?.id === "instituteInfo"
                    ) {
                      navigate(item.route);
                    } else {
                      setModalState({ route: item.route, display: true });
                    }
                  }}
                  className={`newStepperItemOB cursor-pointer ${
                    location?.pathname?.includes(item?.id) ? `newActiveOB` : ""
                  } ${!!item?.status ? "newCompletedOB" : ""}`}
                >
                  <div
                    className={`newStepCounterOB ${
                      location?.pathname?.includes(item?.id)
                        ? "newActiveOB"
                        : ""
                    }`}
                  >
                    <div className="newCounterBubble" />
                  </div>
                  <div className="font-semibold text-[2vh] text-center w-[70%]">
                    Step {index + 1}
                  </div>
                  <div className="text-[2vh] text-center w-[70%] mt-1">
                    {item?.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {getStepObject(location?.pathname)?.length > 1 && (
          <div className="col-span-12 border-y border-solid mx-10 md:hidden">
            <ul className="font-thin text-center text-gray-500 flex">
              {getStepObject(location?.pathname)?.map((item, index) => (
                <li key={"asdnaskjdasjdad" + index + item?.id}>
                  <NavLink
                    end={item?.route === "/old/onboarding/*"}
                    to={item?.route}
                    key={"akjdilqwejhkdhasdasd" + index}
                    type="button"
                    className={renderNavLinkClasses(item?.route)?.value}
                    aria-current={"page"}
                    // style={{ pointerEvents: canNavigate(getStepObject(location?.pathname), index, true) ? "auto" : "none", opacity: canNavigate(getStepObject(location?.pathname), index, true) ? 1 : 0.5 }}
                  >
                    {item?.label}{" "}
                    {!!item?.required && <span className="text-[red]">*</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div
          className={`col-span-12 sm:col-span-12 md:col-span-12 rounded-3xl ${
            getStepObject(location?.pathname)?.length <= 1 && "mt-[1vh]"
          }`}
        >
          <Routes>
            <Route
              path="/instituteInfo"
              element={
                <LF
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/founders"
              element={
                <Leaders
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/faculties"
              element={
                <Faculties
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/recognition"
              element={
                <NewRecognitions
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/testimonials"
              element={
                <NewTestimonials
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/branding"
              element={
                <NewBranding
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/teachers"
              element={
                <Teachers
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/chatbot"
              element={
                <ChatBot
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />{" "}
            <Route
              path="/instituteInfo/campusinfo"
              element={
                <NewCampusInfo
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                  disableForm={undefined}
                />
              }
            />
            <Route
              path="/instituteInfo/preview"
              element={
                <Preview
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/template"
              element={
                <Template
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/instituteInfo/templateMedia"
              element={
                <TemplateMedia
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                  disableForm={undefined}
                />
              }
            />
            <Route
              path="/socialHubInfo"
              element={
                <LinkYourAccounts
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/socialHubInfo/occasions"
              element={
                <Occasions
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/socialHubInfo/notification"
              element={
                <Notifications
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/socialHubInfo/content-engagement"
              element={
                <ContentEngagement
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/autoFeeHub"
              element={
                <NewAutoFeeHub
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/autoConnectHub"
              element={
                <AutoConnectHub
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/aiManagementHub"
              element={
                <AIManagmentHub
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route
              path="/parentalInsights"
              element={
                <ParentInsights
                  handleNavigate={handleNavigate}
                  resetFormData={resetFormData}
                />
              }
            />
            <Route path="/onboarding-complete" element={<ProcessComplete />} />
            <Route path="/onboarding-whatsapp" element={<WhatsApp />} />
          </Routes>
        </div>
      </div>
      <Modal
        isOpen={modalState.display}
        onRequestClose={onRequestClose}
        className="max-w-md m-auto bg-[white] rounded-3xl p-6 shadow-lg outline-none"
        overlayClassName="z-[1100] fixed inset-0 bg-[black] bg-opacity-40 flex justify-center items-start"
      >
        <div className="bg-white w-full p-8">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-6 h-6 text-amber-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Action Required
            </h2>
          </div>

          {/* Content */}
          <div className="text-center mb-8">
            <p className="text-gray-700 leading-relaxed">
              Please complete{" "}
              <span
                className="font-semibold text-blue-600"
                onClick={() => {
                  setModalState({ route: "", display: false });
                  navigate("/old/onboarding/instituteInfo");
                }}
              >
                Step 1
              </span>{" "}
              first to set up your Website information before continuing.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex sm:flex-row gap-3 justify-center">
            <button
              onClick={() => {
                setModalState({ route: "", display: false });
                navigate("/old/onboarding/instituteInfo");
              }}
              className="px-6 py-3 text-sm font-medium text-[#fff] bg-blue-600 rounded-lg hover:bg-blue-700 active:bg-blue-800 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-200 shadow-sm"
            >
              Go to Step 1
            </button>
            <button
              onClick={() => {
                setModalState({ route: "", display: false });
                navigate(modalState.route);
              }}
              className="px-6 py-3 text-sm font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 hover:border-gray-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              Continue Anyway
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const SFR = () => {
  return (
    <ModalProvider>
      <AppProvider>
        <SFRContent />
      </AppProvider>
    </ModalProvider>
  );
};

export default SFR;
